import React from "react";

export interface MobileFilledIconProps {
  id?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  fill?: string;
  inverse?: boolean;
  onClick?: () => void;
}

export const MobileIconFilled = ({
  id,
  width,
  height,
  style,
  fill,
  inverse = false,
  onClick,
}: MobileFilledIconProps) => {
  return (
    <span id={id} style={style} onClick={onClick}>
      <svg height={height} viewBox="0 0 10 20" width={width} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" strokeWidth="1.25">
          <rect fill={fill} height="18.75" rx="2.5" stroke={inverse ? "#FFF" : fill} width="8.75" x=".625" y=".625" />
          <g stroke={"#FFF"} strokeLinecap="square">
            <path d="m3.125 16.875h3.75" />
            <path d="m4.5 2.875h1" />
          </g>
        </g>
      </svg>
    </span>
  );
};
